export const enumTiposGestion = Object.freeze({
  extension: "Extensión de Obra",
  reinicio: "Reinicio de obra",
  edicion: "Edición de Obra",
  suspension: "Suspensión de Obra",
})

export const tipoGestionToEnum = (tipoGestion) => {
  switch (true) {
    case tipoGestion.toLowerCase().includes("extensión"):
      return enumTiposGestion.extension;
    case tipoGestion.toLowerCase().includes("reinicio"):
      return enumTiposGestion.reinicio;
    case tipoGestion.toLowerCase().includes("edición"):
      return enumTiposGestion.edicion;
    case tipoGestion.toLowerCase().includes("suspensión"):
      return enumTiposGestion.suspension;
    default:
      return null;
  }
}